module.exports = "https://static.wmbcdn.com/uniweb/images/c20cacf189514d3196284f8045146e34.svg";